/** Matches `/home/<lifeSpace>/goals` — die Seite „Ziele". */
export const GOALS_PATH_RE = /^\/home\/(personal|work|home)\/goals$/

/**
 * Ob der übergebene Pfad die Seite „Ziele" ist — der einzige Ort, an dem es die
 * rechte Sidebar noch gibt. Überall sonst gibt es weder Panel noch Icon in der
 * Titlebar, und ⌘⇧B hat nichts zu schalten.
 */
export function isGoalsPath(path: string | undefined): boolean {
  return !!path && GOALS_PATH_RE.test(path)
}

/**
 * Ob die rechte Sidebar gerade zu sehen ist. Zwei Bedingungen, die nicht
 * dasselbe sind:
 *
 * - Der Pfad muss „Ziele" sein — sonst gibt es sie überhaupt nicht.
 * - `sidebarRight` ist die gespeicherte Wahl des Users. Sie bleibt erhalten,
 *   während man anderswo unterwegs ist, und gilt wieder, sobald man
 *   zurückkommt.
 */
export function isRightSidebarVisible(state: {
  activeTabPath: string | undefined
  sidebarRight: boolean
}): boolean {
  return isGoalsPath(state.activeTabPath) && state.sidebarRight
}
